$(function() {
  let navLis = $('#footer .nav').children();
  navLis.each(function(index) {
    if((navLis.length - 1) != index) {
      $('<div class="vr d-none d-sm-flex"></div>').insertAfter($(this));
    }
  });
});